import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import AvatarSubscriberList from '../components/AvatarSubscriberList';
const GroupsSubscriber = ({ data }) => {

  const [groupSubscriber, setGroupSubscriber] = useState([]);

  useEffect(() => {
    if (data && data.results) {

      const { groupSubcriberResult } = data.results;

      setGroupSubscriber(groupSubcriberResult);

    }
  }, [data]);



  // Check if data is null or undefined
  if (data === null || data === undefined) {
    // You can return a message or component for when data is not available
    return <p>Data is not available.</p>;
  }

  const avatars = [
    {
      src: 'https://pixinvent.com/materialize-material-design-admin-template/app-assets/images/user/12.jpg',
      alt: 'User 1',
      name: 'mani',
      phoneNumber: '9943',

    },
    {
      src: 'https://htmlstream.com/preview/unify-v2.6.2/assets/img-temp/400x450/img5.jpg',
      alt: 'User 2',
      name: 'mani',
      phoneNumber: '9943',
    },
    {
      src: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
      alt: 'User 3',
      name: 'mani',
      phoneNumber: '9943',
    },
    {
      src: 'https://rimage.gnst.jp/livejapan.com/public/article/detail/a/00/04/a0004213/img/basic/a0004213_main.jpg?20200710184501&q=80&rw=750&rh=536',
      alt: 'User 4',
    },
    {
      src: 'https://da4e1j5r7gw87.cloudfront.net/wp-content/uploads/sites/768/2018/08/glasses-american-man-20s-hipster.jpg',
      alt: 'User 5',
    },
    {
      src: '',
      alt: 'User 5',
    },
    {
      src: 'https://da4e1j5r7gw87.cloudfront.net/wp-content/uploads/sites/768/2018/08/glasses-american-man-20s-hipster.jpg',
      alt: 'User 5',
    },
    {
      src: '',
      alt: 'User 5',
    },
    {
      src: 'https://da4e1j5r7gw87.cloudfront.net/wp-content/uploads/sites/768/2018/08/glasses-american-man-20s-hipster.jpg',
      alt: 'User 5',
    },
    {
      src: '',
      alt: 'User 5',
    },
    {
      src: 'https://da4e1j5r7gw87.cloudfront.net/wp-content/uploads/sites/768/2018/08/glasses-american-man-20s-hipster.jpg',
      alt: 'User 5',
    },

  ];

  return (<section className='section'>
    <Wrapper className='section-center' >
      <h3>Group Subscriber ({groupSubscriber.length})</h3>
      <AvatarSubscriberList groupSubscriber={groupSubscriber} />
    </Wrapper>
  </section>

  );

};
const Wrapper = styled.div`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  margin-bottom:5rem;
  
  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
  /* align-items: start; */
 
`;



export default GroupsSubscriber;
